import React, { Component, Fragment } from 'react';
import download from '../../assets/images/download.svg';
import file from '../../assets/images/file.svg';
import send from '../../assets/images/send.svg';

class Chat extends Component {
    alertOptions = {
        offset: 65,
        position: 'top left',
        theme: 'dark',
        time: 1000,
        transition: 'scale'
    }
    componentDidMount() {
        this.enableMultiSelect()
    }

    enableMultiSelect() {
        // $(document).ready(function () {
        //     $('#range-slct').multiselect();
        // });
    }

    render() {
        return (
            <Fragment>
                <div class="right-section">
                    <div class="row nopadding">
                        <div className="col-md-12">
                            <ul>
                                <li><a href="#" class="chat_css">Style 1</a></li>
                                <li></li>
                                <li><a href="#"></a></li>
                            </ul>
                        </div>
                        <div class="col-md-12 nopadding">
                            <div class="card-container">
                                <div class="row chat-con">
                                    <div class="col-md-12 no-padding left-box">
                                        <div class="col-md-7 nopadding">
                                            <div class="chat-box-left pull-left">
                                                <h6>Hey</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 no-padding right-box">
                                        <div class="col-md-7 no-padding pull-right">
                                            <div class="chat-box-right pull-right">
                                                <h6>Hi</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 no-padding left-box">
                                        <div class="col-md-7 no-padding">
                                            <div class="chat-box-left pull-left">
                                                <div class="chats">
                                                    <img src={download} alt="" />
                                                    <span class="text-info"><a href="#"> XX XX XX</a></span>

                                                    <span class="pull-right chat-date">17th Jan</span>
                                                    <span class="pull-right chat-time">7.30 PM</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 no-padding right-box">
                                        <div class="col-md-7 no-padding pull-right">
                                            <div class="chat-box-right pull-right">
                                                <h6>MM File ? updated..... Bring all the files into single ZIP...
                                                    Lorem ipsum dolor sit amet, animal delicata usu id, mollis aliquip probatus pri et, no sed forensibus referrentur. His movet saperet te, ius no eros nonumy. Tantas ubique fabellas cum cu, movet definiebas persequeris in duo, no ocurreret similique has. Quot mentitum eos no, summo placerat qui ex. Pro tamquam detraxit consequat ex, ad per everti audire accusata, ad ponderum pericula nam.
                                                            </h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 no-padding left-box">
                                        <div class="col-md-7 no-padding">
                                            <div class="chat-box-left pull-left">
                                                <h6>MM File ? updated..... Bring all the files into single ZIP...
                                                    Lorem ipsum dolor sit amet, animal delicata usu id, mollis aliquip probatus pri et, no sed forensibus referrentur. His movet saperet te, ius no eros nonumy. Tantas ubique fabellas cum cu, movet definiebas persequeris in duo, no ocurreret similique has. Quot mentitum eos no, summo placerat qui ex. Pro tamquam detraxit consequat ex, ad per everti audire accusata, ad ponderum pericula nam.
                                                            </h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 no-padding left-box">
                                        <div class="col-md-7 nopadding">
                                            <div class="chat-box-left pull-left">
                                                <h6>MM File Folder !</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 no-padding right-box">
                                        <div class="col-md-7 no-padding pull-right">
                                            <div class="chat-box-right pull-right">
                                                <div class="chats">
                                                    <img src={file} alt="" />
                                                    <span class="text-info"><a href="#">YY YY YY</a></span>

                                                    <span class="pull-right chat-date">17th Jan</span>
                                                    <span class="pull-right chat-time">11.30 PM</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 no-padding left-box">
                                        <div class="col-md-7 nopadding">
                                            <div class="chat-box-left pull-left">
                                                <h6>Thank you!</h6>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="row chat-footer-con">
                                    <div class="col-md-10 px-0">
                                        <div class="chat-textarea">
                                            <textarea type="text" class="form-control" rows="2" cols="50" placeholder="Write a message"></textarea>
                                        </div>

                                    </div>
                                    <div class="col-md-2 chat-footer-btns no-padding">
                                        <div class="col-md-4 no-padding">
                                            <div class="file-field input-field mt-2">
                                                <div class="primary text-center">
                                                    <span><i class="fa fa-paperclip" style={{ fontSize: "30px" }}></i></span>
                                                    <input type="file" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-8 no-padding text-center">
                                            <a href="#" class="primary w-75 mx-auto text-center">
                                                <img src={send} alt="" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default Chat;






// WEBPACK FOOTER //
// ./src/pages/chat/page.js